<template>
    <!-- 小程序运营－小程序售票管理 -->
    <div>
        <content-view  v-show="$utils.renderWhen(this,'miniTicketManage')">
            <a-card
            v-if="shopId && shopId != -1"
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="false" :rowKey="record => record.ticketTemplateId">
                    <template slot="index" slot-scope="a,b,index">{{index+1}}</template>
                    <template slot="empty" slot-scope="key">
                        {{key === null ? '-' : key}}
                    </template>
                    <template slot="isNeedReserve" scope="isNeedReserve">{{isNeedReserve ? '需要预约' : '无需预约'}}</template>
                    <template slot="coverUrl" scope="coverUrl,row">
                        <img class="miniapp-img" preview @click="toPreview(row)" :src="row.imgUrlLittle" alt />
                    </template>
                    <template slot="action" slot-scope="key, item, index">
                        <template v-if="getBtnByAuth('miniTicketSort')">
                            <a v-if="index" @click.stop="sortTicketCategory(item.ticketTemplateId, index, 0)" class="text-primary mr16">上移</a>
                            <span @click.stop v-else class="text-disabled mr16">上移</span>
                            <span @click.stop v-if="index === (dataSource.length - 1)" class="text-disabled mr16">下移</span>
                            <a v-else @click.stop="sortTicketCategory(item.ticketTemplateId, index, 1)" class="text-primary mr16">下移</a>
                            <a v-if="index" @click.stop="sortTicketCategory(item.ticketTemplateId, index, 2)" class="text-primary">移至首位</a>
                            <span @click.stop v-else class="text-disabled mr16">移至首位</span>
                        </template>
                        <template v-else>--</template>
                    </template>
                </a-table>
            </a-card>
            <a-empty v-else>
                <span slot="description" class="font-big22">请切换到各门店查看</span>
            </a-empty>
        </content-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const tabListNoTitle = [
        // {
        //     key: '0',
        //     tab: '热门活动',
        //     columnLine: columns
        // },
        {
            key: '1',
            tab: '门票',
            columnLine: columns
        },
        {
            key: '2',
            tab: '会员卡',
            columnLine: columns
        },
        ]
        const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index"}
        },
        {
            title: "票券id",
            dataIndex: "ticketTemplateId",
        },
        {
            title: "票券封面图",
            dataIndex: "coverUrl",
            scopedSlots: { customRender: "coverUrl"}
        },
        {
            title: "票券展示名称",
            dataIndex: "showName",
        },
        {
            title: "票券内部名称",
            dataIndex: "name",
        },
        {
            title: "售卖价",
            dataIndex: "sellShowPrice"
        },
        {
            title: "预约方式",
            dataIndex: "isNeedReserve",
            scopedSlots: { customRender: "isNeedReserve"}
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "miniTicketManage",
        components: {},
        props: {},
        data() {
            return {
                form: this.$form.createForm(this),
                columns,
                tabListNoTitle,
                dataSource: [],
                noTitleKey: '1',
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        filters: {},
        methods: {
            getMiniSellActivityTicket() {
                this.$api.operation.getMiniSellActivityTicket({
                    body: {
                        suitShopId: this.shopId
                    }
                }).then(res => {
                    this.dataSource = res;
                })
            },
            getMiniSellTicket() {
                this.$api.operation.getMiniSellTicket({
                    body: {
                        suitShopId: this.shopId
                    }
                }).then(res => {
                    res.map(e => {
                        e.imgUrlLittle = e.coverUrl + '?x-oss-process=image/resize,w_200/quality,q_100';
                        return e;
                    })
                    if(this.noTitleKey == 1) {
                        this.dataSource = res.filter(e=>(e.type == 2 && e.useNum ==1))
                    }else {
                        this.dataSource = res.filter(e=>(e.type == 2 && e.useNum >1) || (e.type == 1))
                    }
                })
            },
            toPreview(row) {
                row.imgUrlLittle = row.coverUrl;
            },
            onTabChange(key) {
                this.noTitleKey = key;
                if(key == 0) {
                    this.getMiniSellActivityTicket()
                }else {
                    this.getMiniSellTicket()
                }
            },
            /**
             * 排序
             * operate 0 上移一位，1 下移一位 , 2移至首位
             */
            sortTicketCategory(id, index, operate) {
                let passiveId
                if(operate == 0) {
                    passiveId = this.dataSource[index-1].ticketTemplateId;
                }else if(operate == 1) {
                    passiveId = this.dataSource[index+1].ticketTemplateId;
                }
                this.$api.operation.adjustTicketPosition({
                    body: {
                        id,
                        isRoof: this.noTitleKey == 0,
                        operate,
                        passiveId,
                    }
                }).then(res => {
                    if(this.noTitleKey == 0) {
                        this.getMiniSellActivityTicket()
                    }else {
                        this.getMiniSellTicket()
                    }
                    this.$message.success('操作成功');
                })
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getMiniSellTicket();
        },
        watch: {
            '$route'(val) {
                val.name == 'miniTicketManage' && this.getMiniSellTicket();
            },
            shopId(val) {
                if(val && val != -1) {
                    this.noTitleKey = '1';
                    this.getMiniSellTicket();
                }
            }
        }
    };
</script>
<style scoped>
    .miniapp-img {
        width: 306px;
        height: 169px;
    }
</style>